import { isMock } from '../config'
import { notificacionesMock } from './mock'
import { notificacionesReal } from './real'
import type { NotificacionesService } from './types'

export const notificacionesService: NotificacionesService = isMock('notificaciones') ? notificacionesMock : notificacionesReal
export { holderProfile } from './real'
export { SAVE_DATA_CONSENT_TEXT_VERSION } from './types'
export type { DataRequests, GuestProfile, NoticeChannel, NoticePreference, NoticeType, NotificacionesService, NoticesStay, SaveDataConsent, SaveDataConsentInput, SentNotice } from './types'
